const entities = {
  system: {
    label: 'System',
    label_plural: 'Systems',
    id: 'System ID',
    name: 'System Name',
    apiKey: 'API Key',
    webhookUrl: 'Webhook URL',
    copyApiKey: 'Copy API Key',
    tenants: 'Divisions',
    data: {
      label: 'System Data',
      partnerId: 'TowPay Partner ID',
      ppiFeatureFlags: {
        label: 'PPI Feature Flags',
        allowJobCancellation: 'Allow PPI Job Cancellation',
        allowJobCancellation_details:
          'Allow companies on this system to enable job cancellation from the PPI portal',
      },
    },
  },
  tenant_group: {
    label: 'Account',
    label_plural: 'Accounts',
    id: 'Account ID',
    name: 'Account Name',
    description: 'Description',
    created: 'Created',
    updated: 'Last Updated',
    externalID: 'External ID',
    accountID: 'Account ID',
    traxeroID: 'Salesforce ID',
    status: 'Status',
    data: {
      label: 'Account Data',
      label_plural: 'Account Data',
      permitsEnabled: 'Permits Enabled',
      permitsEnabled_details:
        'Enable permits for this account and its divisions',
      systems: 'Systems',
      maxProperties: 'Max. Properties',
      maxUsers: 'Max. Users',
    },
    tenants: 'Divisions',
    users: 'Users',
  },
  tenant: {
    menu: 'Company Setup',
    label: 'Division',
    label_one: 'Division',
    label_other: 'Divisions',
    label_plural: 'Divisions',
    id: 'Division ID',
    name: 'Division Name',
    systemName: 'TMS',
    systemID: 'TMS ID',
    externalID: 'External ID',
    traxeroID: 'Salesforce ID',
    accountID: 'Account ID',
    contact: {
      label: 'Primary Contact',
      label_plural: 'Primary Contacts',
      id: 'Contact ID',
      name: 'Contact Name',
      description: 'Contact Title',
      website: 'Website',
      primaryEmail: 'Primary Email',
      secondaryEmail: 'Secondary Email',
      primaryPhone: 'Primary Phone',
      primaryPhoneType: 'Primary Phone Type',
      secondaryPhone: 'Alt. Phone',
      secondaryPhoneType: 'Alt. Phone Type',
      tertiaryPhone: 'Alt. Phone 2',
      tertiaryPhoneType: 'Alt. Phone 2 Type',
      location: {
        label: 'Location',
        label_plural: 'Locations',
        id: 'Location ID',
        street: 'Street Address',
        unit: 'Unit #',
        landmark: 'Landmark',
        city: 'City',
        stateCode: 'State',
        postalCode: 'Postal Code',
        latLng: {
          label: 'GPS Coordinates',
          label_plural: 'GPS Coordinates',
          lat: 'Latitude',
          lng: 'Longitude',
        },
        country: 'Country',
      },
      data: {
        label: 'Contact Data',
        label_plural: 'Contact Data',
        driverLicense: {
          label: 'Driver License',
          number: 'Driver License #',
          state: 'State/Province',
        },
      },
      status: 'Status',
      tenantID: 'Customer Division ID',
    },
    status: 'Status',
    userSessionTimeOut: 'Session Timeout',
    created: 'Created',
    updated: 'Last Updated',
    allowUserCreationTowerRoles_details:
      'Enable role assignment at user creation',
    publicContactInfo: {
      label: 'Public Contact Info',
      label_plural: 'Public Contact Info',
      id: 'Public Contact ID',
      name: 'Public Contact Name',
      description: 'Description',
      website: 'Website',
      primaryEmail: 'Primary Email',
      secondaryEmail: 'Secondary Email',
      primaryPhone: 'Primary Phone',
      primaryPhoneType: 'Primary Phone Type',
      secondaryPhone: 'Alt. Phone',
      secondaryPhoneType: 'Alt. Phone Type',
      tertiaryPhone: 'Alt. Phone 2',
      tertiaryPhoneType: 'Alt. Phone 2 Type',
      location: {
        label: 'Location',
        label_plural: 'Locations',
        id: 'Location ID',
        street: 'Street Address',
        unit: 'Unit #',
        landmark: 'Landmark',
        city: 'City',
        stateCode: 'State',
        postalCode: 'Postal Code',
        latLng: {
          label: 'GPS Coordinates',
          label_plural: 'GPS Coordinates',
          lat: 'Latitude',
          lng: 'Longitude',
        },
        country: 'Country',
      },
      data: {
        label: 'Contact Data',
        label_plural: 'Contact Data',
        driverLicense: {
          label: 'Driver License',
          number: 'Driver License #',
          state: 'State/Province',
        },
      },
      status: 'Status',
      tenantID: 'Company ID',
    },
    data: {
      label: 'Tenant Data',
      contactID: 'Contact ID',
      timeZone: 'Time Zone',
      filterLabels: 'Filter Labels',
      tenantGroupName: 'Customer Name',
      verifyNumberCharactersVIN: 'VIN Verify Length',
      defaultRule: 'Default Rule',
      allowUserCreationTowerRoles: 'Enable user role configuration',
      enableFindMyCar: {
        label: 'Find My Car',
      },
      allowJobCancellationBeforeStatus: {
        label: 'Allow Job Cancellation Before Status',
      },
      useDefaultPublicContact: 'Use Public Contact',
      companyPath: 'Brand URL',
      branding: {
        label: 'Brand Management',
        label_plural: 'Brand Management',
        header: 'Brand Management',
        colorHeader: 'Color Scheme',
        primary: 'Accent Color',
        secondary: 'Primary Color',
        info: 'Info Color',
        logoUrl: 'Logo URL',
        bannerLogoUrl: 'Banner Logo URL',
      },
      savedImportMappings: {
        label: 'Saved Import Mappings',
        label_plural: 'Saved Import Mappings',
      },
      entityMerchant: {
        label: 'Entity Merchant',
        label_plural: 'Entity Merchants',
        merchantID: 'Merchant ID',
        status: 'Enable Towpay',
        data: 'Entity Merchant Data',
      },
      findMyCarMsg: 'Optional Message',
    },
    tenantGroup: 'Account',
    copyTenantID: 'Copy Initial Division ID',
    tenantGroupID: 'Account ID',
    rules: 'Rules',
    permitTypes: 'Permit Types',
    permitPricings: 'Permit Pricing',
    users: 'Users',
    contacts: 'Contacts',
    rulesets: 'Rulesets',
  },
  user: {
    label: 'User',
    label_plural: 'Users',
    jwt: 'JWT',
    jwtToken: 'Token',
    id: 'User ID',
    firstName: 'First Name',
    lastName: 'Last Name',
    registrationToken: 'Registration Token',
    created: 'Created',
    updated: 'Last Updated',
    password: 'Password',
    lastAccessTime: 'Last Accessed',
    status: 'Status',
    email: 'Email Address',
    tenantIDs: 'Customer Division IDs',
    userData: {
      label: 'User Settings',
      label_plural: 'User Settings',
      notifications: {
        label: 'Notifications',
        label_plural: 'Notifications',
        allowNotifications: 'Enable Notifications',
        notificationType: 'Notification Type',
      },
    },
    roles: 'Roles',
    hasPassword: 'Has Password',
    externalID: 'External ID',
    contact: {
      label: 'Contact Info',
      id: 'Contact ID',
      name: 'User Contact Name',
      description: 'User Title',
      website: 'Website',
      primaryEmail: 'Primary Email',
      secondaryEmail: 'Secondary Email',
      primaryPhone: 'Primary Phone',
      primaryPhoneType: 'Type',
      secondaryPhone: 'Alt. Phone',
      secondaryPhoneType: 'Type',
      tertiaryPhone: 'Alt. Phone 2',
      tertiaryPhoneType: 'Type',
      location: {
        label: 'Location',
        label_plural: 'Locations',
        id: 'Location ID',
        unit: 'Unit #',
        street: 'Street Address',
        landmark: 'Landmark',
        city: 'City',
        stateCode: 'State',
        postalCode: 'Postal Code',
        latLng: {
          label: 'GPS Coordinates',
          label_plural: 'GPS Coordinates',
          lat: 'Latitude',
          lng: 'Longitude',
        },
        country: 'Country',
      },
      data: {
        label: 'Contact Data',
        label_plural: 'Contact Data',
        driverLicense: {
          label: 'Driver License',
          number: 'Driver License #',
          state: 'State/Province',
        },
      },
      status: 'Status',
      tenantID: 'Customer Division ID',
    },
  },
  property: {
    label: 'Property',
    label_one: 'Property',
    label_other: 'Properties',
    label_plural: 'Properties',
    id: 'Property ID',
    name: 'Property Name',
    description: 'Description',
    address: 'Address',
    primaryContact: 'Primary Contact',
    contacts: 'Contacts',
    doNotTows: 'Do Not Tow Requests',
    contact: {
      label: 'Contacts',
      label_plural: 'Contacts',
      id: 'Contact ID',
      name: 'Contact Name',
      description: 'Contact Title',
      website: 'Website',
      primaryEmail: 'Primary Email',
      secondaryEmail: 'Secondary Email',
      primaryPhone: 'Primary Phone',
      primaryPhoneType: 'Type',
      secondaryPhone: 'Alt. Phone',
      secondaryPhoneType: 'Type',
      tertiaryPhone: 'Alt. Phone 2',
      tertiaryPhoneType: 'Type',
      location: {
        label: 'Location',
        label_plural: 'Locations',
        id: 'Location ID',
        street: 'Street Address',
        unit: 'Unit #',
        landmark: 'Landmark',
        city: 'City',
        stateCode: 'State',
        postalCode: 'Postal Code',
        latLng: {
          label: 'GPS Coordinates',
          label_plural: 'GPS Coordinates',
          lat: 'Latitude',
          lng: 'Longitude',
        },
        country: 'Country',
      },
      data: {
        label: 'Contact Data',
        label_plural: 'Contact Data',
        driverLicense: {
          label: 'Driver License',
          number: 'Driver License #',
          state: 'State/Province',
        },
      },
      status: 'Status',
      tenantID: 'Customer Division ID',
    },
    location: {
      label: 'Address',
      label_plural: 'Addresses',
      id: 'Location ID',
      street: 'Street Address',
      unit: 'Unit #',
      landmark: 'Landmark',
      city: 'City',
      stateCode: 'State',
      postalCode: 'Postal Code',
      latLng: {
        label: 'GPS Coordinates',
        label_plural: 'GPS Coordinates',
        lat: 'Latitude',
        lng: 'Longitude',
      },
      country: 'Country',
    },
    contactID: 'Primary Contact ID',
    tenantID: 'Division ID',
    type: 'Property Type',
    status: 'Status',
    externalID: 'External ID',
    users: 'Users',
    rules: 'Rules',
    rulesets: 'Rulesets',
    permitTypes: 'Permit Types',
    propertyGroups: 'Property Groups',
    qrCodes: 'QR Codes',
    approvers: 'Approvers',
    data: {
      label: 'Metadata',
      label_plural: 'Metadata',
      Metadata: {
        label: 'data',
        label_plural: 'data',
        DivisionId: 'Division ID',
        BillingCustomerKey: 'Billing Customer Key',
      },
      timeZone: 'Time Zone',
      settings: {
        label: 'Property Settings',
        label_plural: 'Property Settings',
        gateCode: 'Gate Code',
        notes: 'Notes',
        requireTags: 'Deprecated (require tags)',
        notifyPropertyManagerLoginUsers: 'Deprecated (notify property manager)',
        requirePropertyManagerSignature:
          'Deprecated (require property manager signature)',
        requirePMApproval: 'Require Property Manager Approval',
        notifyPM: 'Notify Property Manager',
        enablePatrols: 'Enable Patrols',
        notifyPMPendingPermit: 'Notify Pending Permit',
      },
      branding: {
        label: 'Branding',
        label_plural: 'Branding',
        primary: 'Brand Color',
        secondary: 'Secondary Color',
        logoUrl: 'Icon Logo URL',
        bannerLogoUrl: 'Header Logo URL',
      },
      activeBranding: {
        label: 'Active Branding',
        label_plural: 'Active Branding',
        id: 'Active Branding ID',
        name: 'Active Branding Name',
        entityType: 'Entity Type',
        branding: {
          label: 'Branding',
          label_plural: 'Branding',
          primary: 'Brand Color',
          secondary: 'Secondary Color',
          logoUrl: 'Icon Logo URL',
          bannerLogoUrl: 'Header Logo URL',
        },
        location: {
          label: 'Location',
          label_plural: 'Locations',
          id: 'Location ID',
          street: 'Street Address',
          unit: 'Unit #',
          landmark: 'Landmark',
          city: 'City',
          stateCode: 'State',
          postalCode: 'Postal Code',
        },
        contact: {
          label: 'Contact',
          label_plural: 'Contacts',
          id: 'Contact ID',
          name: 'Contact Name',
          description: 'Contact Title',
          website: 'Website',
          primaryEmail: 'Primary Email',
          secondaryEmail: 'Secondary Email',
          primaryPhone: 'Primary Phone',
          primaryPhoneType: 'Type',
          secondaryPhone: 'Alt. Phone',
          secondaryPhoneType: 'Type',
          tertiaryPhone: 'Alt. Phone 2',
          tertiaryPhoneType: 'Type',
          location: {
            label: 'Contact Location',
            label_plural: 'Contact Locations',
            id: 'Location ID',
            street: 'Street Address',
            unit: 'Unit #',
            landmark: 'Landmark',
            city: 'City',
            stateCode: 'State',
            postalCode: 'Postal Code',
          },
          data: {
            label: 'Contact Data',
            label_plural: 'Contact Data',
            driverLicense: {
              label: 'Driver License',
              number: 'Driver License #',
              state: 'State/Province',
            },
          },
        },
      },
      filterLabels: {
        label: 'Filter Labels',
        label_plural: 'Filter Labels',
      },
      disableFindMyCar: 'Disable Find My Car',
      disableTowing: 'Do Not Tow',
      entityMerchant: {
        label: 'Entity Merchant',
        label_plural: 'Entity Merchants',
        merchantID: 'Merchant ID',
        status: 'Status',
        data: 'Entity Merchant Data',
      },
    },
  },
  property_group: {
    label: 'Property Group',
    label_plural: 'Property Groups',
    id: 'Group ID',
    name: 'Group Name',
    description: 'Description',
    status: 'Status',
    primaryContact: {
      label: 'Primary Contact',
      label_plural: 'Primary Contacts',
      id: 'Contact ID',
      name: 'Contact Name',
      description: 'Contact Title',
      website: 'Website',
      primaryEmail: 'Primary Email',
      secondaryEmail: 'Secondary Email',
      primaryPhone: 'Primary Phone',
      primaryPhoneType: 'Type',
      secondaryPhone: 'Alt. Phone',
      secondaryPhoneType: 'Type',
      tertiaryPhone: 'Alt. Phone 2',
      tertiaryPhoneType: 'Type',
      location: {
        label: 'Location',
        label_plural: 'Locations',
        id: 'Location ID',
        unit: 'Unit #',
        street: 'Street Address',
        landmark: 'Landmark',
        city: 'City',
        stateCode: 'State',
        postalCode: 'Postal Code',
        latLng: {
          label: 'GPS Coordinates',
          label_plural: 'GPS Coordinates',
          lat: 'Latitude',
          lng: 'Longitude',
        },
        country: 'Country',
      },
      data: {
        label: 'Contact Data',
        label_plural: 'Contact Data',
        driverLicense: {
          label: 'Driver License',
          number: 'Driver License #',
          state: 'State/Province',
        },
      },
      status: 'Status',
      tenantID: 'Customer Division ID',
    },
    contacts: {
      label: 'Contacts',
      label_plural: 'Contacts',
      id: 'Contact ID',
      name: 'Contact Name',
      description: 'Contact Title',
      website: 'Website',
      primaryEmail: 'Primary Email',
      secondaryEmail: 'Secondary Email',
      primaryPhone: 'Primary Phone',
      primaryPhoneType: 'Type',
      secondaryPhone: 'Alt. Phone',
      secondaryPhoneType: 'Type',
      tertiaryPhone: 'Alt. Phone 2',
      tertiaryPhoneType: 'Type',
      location: {
        label: 'Location',
        label_plural: 'Locations',
        id: 'Location ID',
        unit: 'Unit #',
        street: 'Street Address',
        landmark: 'Landmark',
        city: 'City',
        stateCode: 'State',
        postalCode: 'Postal Code',
        latLng: {
          label: 'GPS Coordinates',
          label_plural: 'GPS Coordinates',
          lat: 'Latitude',
          lng: 'Longitude',
        },
        country: 'Country',
      },
      data: {
        label: 'Contact Data',
        label_plural: 'Contact Data',
        driverLicense: {
          label: 'Driver License',
          number: 'Driver License #',
          state: 'State/Province',
        },
      },
      status: 'Status',
      tenantID: 'Customer Division ID',
    },
    location: {
      label: 'Business Address',
      label_plural: 'Business Addresses',
      street: 'Street Address',
      unit: 'Unit #',
      city: 'City',
      stateCode: 'State',
      postalCode: 'Postal Code',
    },
    contactID: 'Primary Contact ID',
    properties: 'Properties',
    rules: 'Rules',
    rulesets: 'Rulesets',
    permitTypes: 'Permit Types',
    qrCodes: 'QR Codes',
    permitPricings: 'Permit Pricing',
    users: 'Users',
    tenantID: 'Customer Division ID',
    externalID: 'External ID',
    approvers: 'Approvers',
    data: {
      label: 'Metadata',
      label_plural: 'Metadata',
      settings: {
        label: 'Property Group Settings',
        label_plural: 'Property Group Settings',
        requireTags: 'Deprecated (require tags)',
        notifyPropertyManagerLoginUsers: 'Deprecated (notify property manager)',
        requirePropertyManagerSignature:
          'Deprecated (require property manager signature)',
        requirePMApproval: 'Require Property Manager Approval',
        notifyPM: 'Notify Property Manager',
      },
      branding: {
        label: 'Branding',
        label_plural: 'Branding',
        primary: 'Brand Color',
        secondary: 'Secondary Color',
        logoUrl: 'Icon Logo URL',
        bannerLogoUrl: 'Header Logo URL',
      },
      entityMerchant: {
        label: 'Entity Merchant',
        label_plural: 'Entity Merchants',
        merchantID: 'Merchant ID',
        status: 'Status',
        data: 'Entity Merchant Data',
      },
    },
  },
  rule: {
    label: 'Rule',
    label_plural: 'Rules',
    id: 'Rule ID',
    name: 'Rule Name',
    description: 'Description',
    created: 'Created',
    updated: 'Last Updated',
    status: 'Status',
    startDate: 'Start Date',
    endDate: 'End Date',
    type: 'Rule Types',
    vehicle: {
      label: 'Vehicle',
      label_plural: 'Vehicles',
      id: 'Vehicle ID',
      year: 'Year',
      make: 'Make',
      model: 'Model',
      color: 'Color',
      plate: {
        label: 'License Plate',
        label_plural: 'License Plates',
        number: 'Plate Number',
        state: 'Plate State',
        exp: 'Plate Exp.',
      },
      trim: 'Trim',
      vin: 'VIN',
    },
    tenantID: 'Customer Division ID',
    data: {
      label: 'Rule Data',
      label_plural: 'Rule Data',
      tagHours: 'Tag Duration (hours)',
      enforcementSchedule: {
        label: 'Enforcement Schedule',
        label_plural: 'Enforcement Schedules',
        sunday: {
          label: 'Sunday',
          label_plural: 'Sundays',
          startTime: 'Start Time',
          endTime: 'End Time',
        },
        monday: {
          label: 'Monday',
          label_plural: 'Mondays',
          startTime: 'Start Time',
          endTime: 'End Time',
        },
        tuesday: {
          label: 'Tuesday',
          label_plural: 'Tuesdays',
          startTime: 'Start Time',
          endTime: 'End Time',
        },
        wednesday: {
          label: 'Wednesday',
          label_plural: 'Wednesdays',
          startTime: 'Start Time',
          endTime: 'End Time',
        },
        thursday: {
          label: 'Thursday',
          label_plural: 'Thursdays',
          startTime: 'Start Time',
          endTime: 'End Time',
        },
        friday: {
          label: 'Friday',
          label_plural: 'Fridays',
          startTime: 'Start Time',
          endTime: 'End Time',
        },
        saturday: {
          label: 'Saturday',
          label_plural: 'Saturdays',
          startTime: 'Start Time',
          endTime: 'End Time',
        },
      },
      violations: {
        label: 'Violations',
        label_plural: 'Violations',
        id: 'Violation ID',
        name: 'Violation Name',
        description: 'Description',
        status: 'Status',
        tenantID: 'Customer Division ID',
        standard: 'Standard',
      },
      holidayExceptions: {
        label: 'Holiday Exceptions',
        label_plural: 'Holiday Exceptions',
        id: 'Holiday ID',
        name: 'Holiday Name',
        date: 'Date',
      },
      ruleType: 'Rule Type',
    },
    ancestry: {
      label: 'Ancestry',
      label_plural: 'Ancestries',
      id: 'Ancestry ID',
      name: 'Ancestry Name',
      description: 'Description',
      status: 'Status',
      tenantID: 'Customer Division ID',
    },
  },
  ruleset: {
    label: 'Ruleset',
    label_plural: 'Rulesets',
    id: 'Ruleset ID',
    name: 'Ruleset Name',
    description: 'Description',
    ruleIDs: 'Rule IDs',
    rules: {
      label: 'Rule',
      label_plural: 'Rules',
      id: 'Rule ID',
      name: 'Rule Name',
      description: 'Description',
      status: 'Status',
      startDate: 'Start Date',
      endDate: 'End Date',
      vehicle: {
        label: 'Vehicle',
        label_plural: 'Vehicles',
        id: 'Vehicle ID',
        year: 'Year',
        make: 'Make',
        model: 'Model',
        color: 'Color',
        plate: {
          label: 'License Plate',
          label_plural: 'License Plates',
          number: 'Plate Number',
          state: 'Plate State',
          exp: 'Plate Exp.',
        },
        trim: 'Trim',
        vin: 'VIN',
      },
      tenantID: 'Customer Division ID',
      data: {
        label: 'Rule Data',
        label_plural: 'Rule Data',
        tagHours: 'Tag Duration (hours)',
        enforcementSchedule: {
          label: 'Enforcement Schedule',
          label_plural: 'Enforcement Schedules',
          sunday: {
            label: 'Sunday',
            label_plural: 'Sundays',
            startTime: 'Start Time',
            endTime: 'End Time',
          },
          monday: {
            label: 'Monday',
            label_plural: 'Mondays',
            startTime: 'Start Time',
            endTime: 'End Time',
          },
          tuesday: {
            label: 'Tuesday',
            label_plural: 'Tuesdays',
            startTime: 'Start Time',
            endTime: 'End Time',
          },
          wednesday: {
            label: 'Wednesday',
            label_plural: 'Wednesdays',
            startTime: 'Start Time',
            endTime: 'End Time',
          },
          thursday: {
            label: 'Thursday',
            label_plural: 'Thursdays',
            startTime: 'Start Time',
            endTime: 'End Time',
          },
          friday: {
            label: 'Friday',
            label_plural: 'Fridays',
            startTime: 'Start Time',
            endTime: 'End Time',
          },
          saturday: {
            label: 'Saturday',
            label_plural: 'Saturdays',
            startTime: 'Start Time',
            endTime: 'End Time',
          },
        },
        violations: {
          label: 'Violations',
          label_plural: 'Violations',
          id: 'Violation ID',
          name: 'Violation Name',
          description: 'Description',
          status: 'Status',
          tenantID: 'Customer Division ID',
          standard: 'Standard',
        },
        holidayExceptions: {
          label: 'Holiday Exceptions',
          label_plural: 'Holiday Exceptions',
          id: 'Holiday ID',
          name: 'Holiday Name',
          date: 'Date',
        },
        ruleType: {
          label: 'Rule Type',
        },
      },
    },
    tenantID: 'Customer Division ID',
    status: 'Status',
    created: 'Created',
    updated: 'Updated',
    ancestry: {
      label: 'Ancestry',
      label_plural: 'Ancestries',
      id: 'Ancestry ID',
      name: 'Ancestry Name',
      description: 'Description',
      status: 'Status',
      tenantID: 'Customer Division ID',
    },
  },
  violation: {
    label: 'Violation',
    label_plural: 'Violations',
    name: 'Violation Name',
    status: 'Status',
    description: 'Description',
    id: 'Violation ID',
    tenantID: 'Customer Division ID',
  },
  instruction: {
    label: 'Instruction',
    label_plural: 'Instructions',
    title: 'Title',
    text: 'Driver Instructions',
    image: 'Image',
  },
  qrCodes: {
    label: 'QR Code',
    label_plural: 'QR Codes',
    name: 'QR Code Name',
    description: 'QR Code Description',

    fileKey: 'File Key',
    createdByUserID: 'Created By User ID',
    tenantID: 'Customer Division ID',
    entityType: 'Entity Type',
    entityID: 'Entity ID',
    fileType: 'File Type',
    location: {
      label: 'Location',
      label_plural: 'Locations',
      id: 'Location ID',
      street: 'Street Address',
      unit: 'Unit #',
      landmark: 'Landmark',
      city: 'City',
      stateCode: 'State',
    },
    uploadFileURL: 'Upload File URL',
    downloadFileURL: 'Download File URL',
    created: 'Created',
    errorMsg: 'Error Message',
    data: {
      label: 'QR Code Data',
      label_plural: 'QR Code Data',
      title: 'Title',
      description: 'Description',
      permanent: 'Make URL permanent',
      content: 'Content',
    },
  },
  job: {
    label: 'Job',
    label_plural: 'Jobs',
    id: 'Job ID',
    externalID: 'External ID',
    propertyID: 'Property ID',
    property: {
      label: 'Property',
      label_plural: 'Properties',
      id: 'Property ID',
      name: 'Property Name',
      description: 'Description',
      address: 'Address',
      primaryContact: 'Primary Contact',
      contact: {
        label: 'Contacts',
        label_plural: 'Contacts',
        id: 'Contact ID',
        name: 'Contact Name',
        description: 'Contact Title',
        website: 'Website',
        primaryEmail: 'Primary Email',
        secondaryEmail: 'Secondary Email',
        primaryPhone: 'Primary Phone',
        primaryPhoneType: 'Type',
        secondaryPhone: 'Alt. Phone',
        secondaryPhoneType: 'Type',
        tertiaryPhone: 'Alt. Phone 2',
        tertiaryPhoneType: 'Type',
        location: {
          label: 'Location',
          label_plural: 'Locations',
          id: 'Location ID',
          street: 'Street Address',
          unit: 'Unit #',
          landmark: 'Landmark',
          city: 'City',
          stateCode: 'State',
          postalCode: 'Postal Code',
          latLng: {
            label: 'GPS Coordinates',
            label_plural: 'GPS Coordinates',
            lat: 'Latitude',
            lng: 'Longitude',
          },
          country: 'Country',
        },
        data: {
          label: 'Contact Data',
          label_plural: 'Contact Data',
          driverLicense: {
            label: 'Driver License',
            number: 'Driver License #',
            state: 'State/Province',
          },
        },
        status: 'Status',
        tenantID: 'Customer Division ID',
      },
      location: {
        label: 'Property Location',
        label_plural: 'Property Locations',
        id: 'Property Location ID',
        street: 'Street Address',
        unit: 'Unit #',
        landmark: 'Landmark',
        city: 'City',
        stateCode: 'State',
        postalCode: 'Postal Code',
        latLng: {
          label: 'GPS Coordinates',
          label_plural: 'GPS Coordinates',
          lat: 'Latitude',
          lng: 'Longitude',
        },
        country: 'Country',
      },
      contactID: 'Primary Contact ID',
      tenantID: 'Division ID',
      type: 'Property Type',
      status: 'Status',
      externalID: 'External ID',
    },
    propertyName: 'Property Name',
    tenantID: 'Customer Division ID',
    tenant: {
      label: 'Tenant',
      label_plural: 'Tenants',
      id: 'Tenant ID',
      name: 'Tenant Name',
      systemName: 'System Name',
      status: 'Status',
    },
    createdByUserID: 'Created By User ID',
    createdByUserName: 'Created By User Name',
    requestTime: 'Request Time',
    contactPhone: 'Contact Phone',
    signatures: {
      label: 'Signature',
      label_plural: 'Signatures',
      id: 'Signature ID',
      description: 'Description',
      fileKey: 'File Key',
      signedByUserID: 'Signed By UserID',
      signedByUserName: 'Signed By',
      signedAt: 'Signed At',
      entityTypeID: 'Entity Type ID',
      entityID: 'Entity ID',
      tenantID: 'Customer Division ID',
      systemID: 'System ID',
      ipAddress: 'IP Address',
      location: {
        label: 'Location',
        label_plural: 'Locations',
        id: 'Location ID',
        street: 'Street Address',
        unit: 'Unit #',
        landmark: 'Landmark',
        city: 'City',
        stateCode: 'State',
        postalCode: 'Postal Code',
        latLng: {
          label: 'GPS Coordinates',
          label_plural: 'GPS Coordinates',
          lat: 'Latitude',
          lng: 'Longitude',
        },
        country: 'Country',
      },
    },
    vehicle: {
      label: 'Vehicle',
      label_plural: 'Vehicles',
      id: 'Vehicle ID',
      year: 'Year',
      make: 'Make',
      model: 'Model',
      color: 'Color',
      plate: {
        label: 'License Plate',
        label_plural: 'License Plates',
        number: 'Plate Number',
        state: 'Plate State',
        exp: 'Plate Exp.',
      },
      trim: 'Trim',
      vin: 'VIN',
    },
    location: {
      label: 'Location',
      label_plural: 'Locations',
      id: 'Location ID',
      street: 'Street Address',
      unit: 'Unit #',
      landmark: 'Landmark',
      city: 'City',
      stateCode: 'State',
      postalCode: 'Postal Code',
      latLng: {
        label: 'GPS Coordinates',
        label_plural: 'GPS Coordinates',
        lat: 'Latitude',
        lng: 'Longitude',
      },
      country: 'Country',
    },
    plate: {
      label: 'License Plate',
      label_plural: 'License Plates',
      number: 'Plate Number',
      state: 'Plate State',
      exp: 'Plate Exp.',
    },
    fileUploads: {
      label: 'File Uploads',
      label_plural: 'File Uploads',
      fileKey: 'File Key',
      createdByUserID: 'Created By User ID',
      tenantID: 'Customer Division ID',
      entityType: 'Entity Type',
      entityID: 'Entity ID',
      fileType: 'File Type',
      uploadFileURL: 'Upload File URL',
      downloadFileURL: 'Download File URL',
      created: 'Created',
      errorMsg: 'Error Message',
    },
    files: {
      label: 'Files',
      label_plural: 'Files',
      fileKey: 'File Key',
      url: 'URL',
      previewUrl: 'Preview URL',
      fileType: 'File Type',
      title: 'Title',
    },
    status: 'Status',
    type: 'Job Type',
    created: 'Created',
    updated: 'Updated',
    data: {
      label: 'Job Data',
      label_plural: 'Job Data',
      notes: 'Notes',
      violations: {
        label: 'Violations',
        label_plural: 'Violations',
        id: 'Violation ID',
        name: 'Violation Name',
        description: 'Description',
        status: 'Status',
      },
      statuses: {
        label: 'Job Statuses',
        label_plural: 'Job Statuses',
        status: 'Status',
        timestamp: 'Timestamp',
        displayTime: 'Display Time',
        reason: 'Reason',
        location: {
          label: 'Location',
          label_plural: 'Locations',
          id: 'Location ID',
          street: 'Street Address',
          unit: 'Unit #',
          landmark: 'Landmark',
          city: 'City',
          stateCode: 'State',
          postalCode: 'Postal Code',
          latLng: {
            label: 'GPS Coordinates',
            label_plural: 'GPS Coordinates',
            lat: 'Latitude',
            lng: 'Longitude',
          },
          country: 'Country',
        },
        contact: {
          label: 'Contact',
          label_plural: 'Contacts',
          id: 'Contact ID',
          name: 'Contact Name',
          description: 'Description',
          website: 'Website',
          primaryEmail: 'Primary Email',
          secondaryEmail: 'Secondary Email',
          primaryPhone: 'Primary Phone',
          primaryPhoneType: 'Primary Phone Type',
          secondaryPhone: 'Secondary Phone',
          secondaryPhoneType: 'Secondary Phone Type',
          tertiaryPhone: 'Tertiary Phone',
          tertiaryPhoneType: 'Tertiary Phone Type',
          location: {
            label: 'Location',
            label_plural: 'Locations',
            id: 'Location ID',
            street: 'Street Address',
            unit: 'Unit #',
            landmark: 'Landmark',
            city: 'City',
            stateCode: 'State',
            postalCode: 'Postal Code',
            latLng: {
              label: 'GPS Coordinates',
              label_plural: 'GPS Coordinates',
              lat: 'Latitude',
              lng: 'Longitude',
            },
            country: 'Country',
          },
          data: {
            label: 'Contact Data',
            label_plural: 'Contact Data',
            driverLicense: {
              label: 'Driver License',
              number: 'Driver License #',
              state: 'State/Province',
            },
          },
          status: 'Status',
          tenantID: 'Customer Division ID',
        },
      },
      contactPhone: 'Contact Phone',
      landmark: 'Landmark',
    },
  },
  contact: {
    label: 'Contact',
    label_plural: 'Contacts',
    id: 'Contact ID',
    name: 'Contact Name',
    description: 'Description',
    website: 'Website',
    primaryEmail: 'Primary Email',
    secondaryEmail: 'Secondary Email',
    primaryPhone: 'Primary Phone',
    primaryPhoneMobile: 'Phone',
    primaryPhoneType: 'Type',
    secondaryPhone: 'Alt. Phone',
    secondaryPhoneMobile: 'Alt. Phone',
    secondaryPhoneType: 'Type',
    tertiaryPhone: 'Alt. Phone 2',
    tertiaryPhoneMobile: 'Alt. Phone 2',
    tertiaryPhoneType: 'Type',
    locationID: 'Location ID',
    type: 'Type',
    location: {
      label: 'Location',
      label_plural: 'Locations',
      id: 'Location ID',
      street: 'Street Address',
      unit: 'Unit #',
      landmark: 'Landmark',
      city: 'City',
      stateCode: 'State',
      postalCode: 'Postal Code',
      latLng: {
        label: 'GPS Coordinates',
        label_plural: 'GPS Coordinates',
        lat: 'Latitude',
        lng: 'Longitude',
      },
      country: 'Country',
    },
    data: {
      label: 'Contact Data',
      label_plural: 'Contact Data',
      driverLicense: {
        label: 'Driver License',
        number: 'Driver License #',
        state: 'State/Province',
      },
    },
    ancestry: {
      label: 'Ancestry',
      label_plural: 'Ancestries',
      id: 'Ancestry ID',
      name: 'Ancestry Name',
      description: 'Description',
      status: 'Status',
      tenantID: 'Customer Division ID',
    },
    status: 'Status',
    tenantID: 'Customer Division ID',
  },
  vehicle: {
    label: 'Vehicle',
    label_plural: 'Vehicles',
    id: 'Vehicle ID',
    year: 'Year',
    make: 'Make',
    model: 'Model',
    color: 'Color',
    plate: {
      label: 'License Plate',
      label_plural: 'License Plates',
      number: 'Plate Number',
      state: 'State/Province',
      exp: 'Plate Exp.',
      score: 'Score',
      boundingPoly: {
        label: 'Bounding Polygon',
        label_plural: 'Bounding Polygons',
        vertices: {
          label: 'Vertices',
          label_plural: 'Vertices',
          x: 'X Coordinate',
          y: 'Y Coordinate',
        },
        normalizedVertices: {
          label: 'Normalized Vertices',
          label_plural: 'Normalized Vertices',
          x: 'X Coordinate',
          y: 'Y Coordinate',
        },
      },
    },
    trim: 'Trim',
    vin: 'VIN',
    towerContactInfo: {
      label: 'Tower Contact Info',
      label_plural: 'Tower Contact Info',
      id: 'Contact ID',
      name: 'Contact Name',
      description: 'Description',
      website: 'Website',
      primaryEmail: 'Primary Email',
      secondaryEmail: 'Secondary Email',
      primaryPhone: 'Primary Phone',
      primaryPhoneType: 'Primary Phone Type',
      secondaryPhone: 'Secondary Phone',
      secondaryPhoneType: 'Secondary Phone Type',
      tertiaryPhone: 'Tertiary Phone',
      tertiaryPhoneType: 'Tertiary Phone Type',
      location: {
        label: 'Location',
        label_plural: 'Locations',
        id: 'Location ID',
        street: 'Street Address',
        unit: 'Unit #',
        landmark: 'Landmark',
        city: 'City',
        stateCode: 'State',
        postalCode: 'Postal Code',
        latLng: {
          label: 'GPS Coordinates',
          label_plural: 'GPS Coordinates',
          lat: 'Latitude',
          lng: 'Longitude',
        },
        country: 'Country',
      },
      data: {
        label: 'Contact Data',
        label_plural: 'Contact Data',
        driverLicense: {
          label: 'Driver License',
          number: 'Driver License #',
          state: 'State/Province',
        },
      },
      status: 'Status',
      tenantID: 'Customer Division ID',
    },
    NCICCode: 'NCIC Code',
    score: 'Score',
    generation: {
      label: 'Generation',
      label_plural: 'Generations',
      start: 'Start Year',
      end: 'End Year',
    },
  },
  file: {
    label: 'File',
    label_plural: 'Files',
    fileKey: 'File Key',
    createdByUserID: 'Created By User ID',
    tenantID: 'Customer Division ID',
    entityType: 'Entity Type',
    entityID: 'Entity ID',
    fileType: 'File Type',
    location: {
      label: 'Location',
      label_plural: 'Locations',
      id: 'Location ID',
      street: 'Street Address',
      unit: 'Unit #',
      landmark: 'Landmark',
      city: 'City',
      stateCode: 'State',
      postalCode: 'Postal Code',
      latLng: {
        label: 'GPS Coordinates',
        label_plural: 'GPS Coordinates',
        lat: 'Latitude',
        lng: 'Longitude',
      },
      country: 'Country',
    },
    uploadFileURL: 'Upload File URL',
    downloadFileURL: 'Download File URL',
    created: 'Created',
    errorMsg: 'Error Message',
    data: {
      label: 'File Data',
      label_plural: 'File Data',
      title: 'Title',
      description: 'Description',
      permanent: 'Permanent',
      content: 'Content',
    },
  },
  permit: {
    label: 'Permit',
    label_plural: 'Permits',
    id: 'Permit ID',
    created: 'Created',
    updated: 'Updated',
    inviteStatus: 'Invite Status',
    permitStatus: 'Permit Status',
    permitNumber: 'Permit Number',
    startTime: 'Start Time',
    endTime: 'End Time',
    vehicle: {
      label: 'Vehicle',
      label_plural: 'Vehicles',
      id: 'Vehicle ID',
      year: 'Year',
      make: 'Make',
      model: 'Model',
      color: 'Color',
      plate: {
        label: 'License Plate',
        label_plural: 'License Plates',
        number: 'Plate Number',
        state: 'Plate State',
        exp: 'Plate Exp.',
      },
      trim: 'Trim',
      vin: 'VIN',
    },
    property: {
      label: 'Property',
      label_plural: 'Properties',
      id: 'Property ID',
      name: 'Property Name',
      description: 'Description',
      address: 'Address',
      primaryContact: 'Primary Contact',
      contact: {
        label: 'Contacts',
        label_plural: 'Contacts',
        id: 'Contact ID',
        name: 'Contact Name',
        description: 'Contact Title',
        website: 'Website',
        primaryEmail: 'Primary Email',
        secondaryEmail: 'Secondary Email',
        primaryPhone: 'Primary Phone',
        primaryPhoneType: 'Type',
        secondaryPhone: 'Alt. Phone',
        secondaryPhoneType: 'Type',
        tertiaryPhone: 'Alt. Phone 2',
        tertiaryPhoneType: 'Type',
        location: {
          label: 'Location',
          label_plural: 'Locations',
          id: 'Location ID',
          street: 'Street Address',
          unit: 'Unit #',
          landmark: 'Landmark',
          city: 'City',
          stateCode: 'State',
          postalCode: 'Postal Code',
          latLng: {
            label: 'GPS Coordinates',
            label_plural: 'GPS Coordinates',
            lat: 'Latitude',
            lng: 'Longitude',
          },
          country: 'Country',
        },
        data: {
          label: 'Contact Data',
          label_plural: 'Contact Data',
          driverLicense: {
            label: 'Driver License',
            number: 'Driver License #',
            state: 'State/Province',
          },
        },
        status: 'Status',
        tenantID: 'Customer Division ID',
      },
      location: {
        label: 'Property Location',
        label_plural: 'Property Locations',
        id: 'Property Location ID',
        street: 'Street Address',
        unit: 'Unit #',
        landmark: 'Landmark',
        city: 'City',
        stateCode: 'State',
        postalCode: 'Postal Code',
        latLng: {
          label: 'GPS Coordinates',
          label_plural: 'GPS Coordinates',
          lat: 'Latitude',
          lng: 'Longitude',
        },
        country: 'Country',
      },
      contactID: 'Primary Contact ID',
      tenantID: 'Division ID',
      type: 'Property Type',
      status: 'Status',
      externalID: 'External ID',
    },
    propertyGroup: {
      label: 'Property Group',
      label_plural: 'Property Groups',
      id: 'Property Group ID',
      name: 'Property Group Name',
      description: 'Description',
      status: 'Status',
      tenantID: 'Customer Division ID',
    },
    contact: {
      label: 'Contact',
      label_plural: 'Contacts',
      id: 'Contact ID',
      name: 'Owner Name',
      description: 'Description',
      website: 'Website',
      primaryEmail: 'Email',
      secondaryEmail: 'Secondary Email',
      primaryPhone: 'Phone',
      primaryPhoneType: 'Primary Phone Type',
      secondaryPhone: 'Secondary Phone',
      secondaryPhoneType: 'Secondary Phone Type',
      tertiaryPhone: 'Tertiary Phone',
      tertiaryPhoneType: 'Tertiary Phone Type',
      location: {
        label: 'Location',
        label_plural: 'Locations',
        id: 'Location ID',
        street: 'Street Address',
        unit: 'Unit #',
        landmark: 'Landmark',
        city: 'City',
        stateCode: 'State',
        postalCode: 'Postal Code',
        latLng: {
          label: 'GPS Coordinates',
          label_plural: 'GPS Coordinates',
          lat: 'Latitude',
          lng: 'Longitude',
        },
        country: 'Country',
      },
      data: {
        label: 'Contact Data',
        label_plural: 'Contact Data',
        driverLicense: {
          label: 'Driver License',
          number: 'Driver License #',
          state: 'State/Province',
        },
      },
      status: 'Status',
      tenantID: 'Customer Division ID',
    },
    permitType: {
      label: 'Permit Type',
      label_plural: 'Permit Types',
      id: 'Permit Type ID',
      name: 'Permit Type Name',
      description: 'Description',
      status: 'Status',
      tenantID: 'Customer Division ID',
      permitPricingID: 'Permit Pricing ID',
      entityTypeID: 'Entity Type ID',
      entityID: 'Entity ID',
      startDate: 'Start Date',
      endDate: 'End Date',
      created: 'Created',
      updated: 'Updated',
      purchaseLeadTime: 'Purchase Lead Time',
      data: {
        label: 'Permit Type Data',
        label_plural: 'Permit Type Data',
        selfService: 'Self Service',
        needsApproval: 'Needs Approval',
        termsAndConditions: 'Terms and Conditions',
        notifications: {
          label: 'Notifications',
          label_plural: 'Notifications',
          type: 'Notification Type',
          unitOfTime: 'Unit of Time',
          amountOfTime: 'Amount of Time',
        },
        defaultTerm: {
          label: 'Default Term',
          label_plural: 'Default Terms',
          unitOfTime: 'Unit of Time',
          amountOfTime: 'Amount of Time',
        },
        cooldown: {
          label: 'Cooldown',
          label_plural: 'Cooldowns',
          enabled: 'Enabled',
          target: 'Target',
          rate: 'Rate',
          amountOfTime: 'Amount of Time',
          unitOfTime: 'Unit of Time',
        },
        quantityOfSpots: 'Quantity of Spots',
      },
      ancestry: {
        label: 'Ancestry',
        label_plural: 'Ancestries',
        id: 'Ancestry ID',
        name: 'Ancestry Name',
        description: 'Description',
        status: 'Status',
        tenantID: 'Customer Division ID',
      },
    },
    tenant: {
      label: 'Tenant',
      label_plural: 'Tenants',
      id: 'Tenant ID',
      name: 'Tenant Name',
      systemName: 'System Name',
      status: 'Status',
    },
    data: {
      label: 'Permit Data',
      label_plural: 'Permit Data',
      cancelReason: 'Cancel Reason',
      renewalDate: 'Renewal Date',
      spot: 'Spot',
    },
    transactions: {
      label: 'Permit Transaction',
      label_plural: 'Permit Transactions',
      id: 'Transaction ID',
      type: 'Transaction Type',
      amount: 'Amount',
      status: 'Status',
      created: 'Created',
      updated: 'Updated',
      data: {
        label: 'Transaction Data',
        label_plural: 'Transaction Data',
        paymentMethod: 'Payment Method',
        paymentDetails: 'Payment Details',
      },
    },
  },
  permit_type: {
    menu: 'Permit Types',
    label: 'Permit Type',
    label_plural: 'Permit Types',
    createButton: 'Create Type',
    updateButton: 'Update Type',
    addFee: '+ Add Fee',
    id: 'ID',
    name: 'Name',
    description: 'Description',
    status: 'Status',
    created: 'Created',
    updated: 'Last Updated',
    permitDuration: 'Period',
    pricePerUnit: 'Unit Price',
    maxAmountOfUnits: 'Max. Purchasable Units',
    baseRate: 'Base Rate',
    priceBreakdown: 'Price Breakdown',
    permitClientSettings: 'Permit Registration Website Settings',
    startTime: 'Start Time',
    endTime: 'End Time',
    name_placeholder: 'Resident, Guest Permit, Lot 2, etc.',
    description_placeholder: 'Optional description of the permit type',
    unlimited: 'Unlimited',
    permitFees: {
      label: 'Permit Fees',
      short_one: 'Fee',
      short_other: 'Fees',
      id: 'Fee ID',
      name: 'Fee Name',
      description: 'Description',
      fee: 'Fee Amount',
      fee_percent: 'Fee Percentage',
      feeType: 'Fee Type',
      addButton: '+ Add Fee',
    },
    entityData: {
      enforcementSchedule: 'Enforcement Schedule',
      overrideOtherPermits: 'Override Other Permits',
    },
    permitPricing: {
      id: 'ID',
      name: 'Name',
      description: 'Description',
      label: 'Permit Pricing',
      label_plural: 'Permit Pricings',
      maxAmountOfUnits: 'Max Units',
      unitOfTime: 'Unit of Time',
      status: 'Status',
      pricePerUnit: 'Term Fee',
      baseRate: 'Base Rate',
      permitFees: {
        label: 'Permit Fees',
      },
    },
    data: {
      quantityOfSpots: '# of Spots Available',
      notifications: {
        label: 'Notification Settings',
        renewalNudge: 'Send Renewal Reminder Emails',
        unitOfTime: 'Unit of Time',
        amountOfTime: 'Amount of Time Before Expiration',
        expiration: 'Expiration Notification Emails',
        revoked: 'Revocation Notification Emails',
      },
      needsApproval: 'Requires Approval',
      selfService: {
        label: 'Self Service',
        true: 'Self Service',
        false: 'Invite Only {{extra}}',
      },
      defaultTerm: {
        label: 'Default Permit Term',
        unitOfTime: 'Unit of Time',
        amountOfTime: 'Amount of Time',
      },
      cooldown: {
        label: 'Issuance Rate Limiting {{extra}}',
        rate: 'Rate',
        amountOfTime: 'Count',
        unitOfTime: 'Period',
        target: 'Target',
      },
      guestPermitData: {
        label: 'Guest Permit Data',
        enabled: 'Guest Permitting Enabled',
        term: {
          label: 'Guest Permit Term',
          unitOfTime: 'Unit of Time',
          amountOfTime: 'Amount of Time',
        },
        unitOfTime: 'Unit of Time',
        rate: 'Rate',
      },
      fieldConfig: {
        label: 'PermitField Configuration',
        vin: 'VIN',
        color: 'Vehicle Color',
        makeModel: 'Make/Model',
        driverLicense: 'Driver License',
      },
    },
  },
  donottow: {
    label: 'Do Not Tow',
    label_plural: 'Do Not Tow List',
    id: 'Do Not Tow ID',
    tenantID: 'Customer Division ID',
    entityID: 'Valid For ID',
    entityType: 'Valid For Type',
    vin: 'VIN',
    plate: {
      label: 'License Plate',
      label_plural: 'License Plates',
      number: 'Plate Number',
      state: 'Plate State',
      exp: 'Plate Exp.',
    },
    reason: 'Reason',
    status: 'Status',
    startTime: 'Start Time',
    endTime: 'End Time',
    created: 'Created',
    updated: 'Updated',
    ancestry: {
      label: 'Ancestry',
      label_plural: 'Ancestries',
      id: 'Ancestry ID',
      name: 'Ancestry Name',
      description: 'Description',
      status: 'Status',
      tenantID: 'Customer Division ID',
    },
  },
};

export default entities;
